import { FOOTER__master } from '@/pages/_base/layout_footer/FOOTER__master';
import { HEADER__master } from '@/pages/_base/layout_header/HEADER__master';
import { G_HEADER__column_center } from '../../view_header/G_HEADER__column_center';
import { G_HEADER__generation_actions } from '../../view_header/G_HEADER__generation_actions';
import { G_BAR__layout_tabs } from '../_base/G_BAR__layout_tabs';
import { G_SIDEBAR__add_node } from './_sidebars/G_SIDEBAR__add_node';
import { G_SIDEBAR__graph_node_fields } from './_sidebars/G_SIDEBAR__graph_node_fields';
import { G_GRAPH__flow } from './G_GRAPH__flow';

export function G_LAYOUT__generation_nodes() {
  return (
    <>
      <div className="flex flex-col w-full h-screen">
        <HEADER__master column_center={<G_HEADER__column_center />} column_right={<G_HEADER__generation_actions />} />

        <div className="flex flex-row w-full flex-1 min-h-0">
          <G_SIDEBAR__add_node />

          <div className="flex-1 h-full flex flex-col">
            <G_BAR__layout_tabs />
            <G_GRAPH__flow />
          </div>

          <G_SIDEBAR__graph_node_fields />
        </div>

        <FOOTER__master />
      </div>
    </>
  );
}
